
import React from "react";
import { PagePosition } from "@/types/page";
import { Maximize2 } from "lucide-react";
import { 
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue 
} from "@/components/ui/select";

interface PositionSelectorProps {
  position: PagePosition;
  onPositionChange: (position: PagePosition) => void;
}

export const PositionSelector: React.FC<PositionSelectorProps> = ({ 
  position, 
  onPositionChange 
}) => {
  return (
    <div>
      <label className="block mb-2 text-gray-500">מיקום בלוח (מסך מלא בלבד)</label>
      <Select 
        value="fullscreen" 
        onValueChange={() => onPositionChange("fullscreen")}
        disabled
      >
        <SelectTrigger className="w-[150px] bg-gray-50">
          <SelectValue placeholder="מסך מלא" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="fullscreen">
            <div className="flex items-center">
              <Maximize2 className="h-4 w-4 ml-2" />
              <span>מסך מלא</span>
            </div>
          </SelectItem>
        </SelectContent>
      </Select>
      <p className="text-xs text-gray-500 mt-1">
        כל הדפים מוצגים במסך מלא
      </p>
    </div>
  );
};
